import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Landlord.css';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const menuItems = [
    {
      path: '/landlord/dashboard',
      icon: 'fas fa-chart-line',
      label: 'Dashboard'
    },
    {
      path: '/landlord/properties',
      icon: 'fas fa-building',
      label: 'My Properties'
    },
    {
      path: '/landlord/add-property',
      icon: 'fas fa-plus-circle',
      label: 'Add Property',
    },
    {
      path: '/landlord/conversations',
      icon: 'fas fa-envelope',
      label: 'Inquiries'
    },
    {
      path: '/landlord/profile',
      icon: 'fas fa-user-circle',
      label: 'Profile'
    },
    {
      path: '/landlord/settings',
      icon: 'fas fa-cog',
      label: 'Settings'
    }
  ];

  const handleLinkClick = () => {
    if (window.innerWidth <= 991) {
      onClose();
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const renderMenuItem = (item) => {
    if (item.type === 'dropdown') {
      return (
        <div key={item.label} className="sidebar-dropdown">
          <div 
            className={`sidebar-link dropdown-toggle ${
              isDropdownOpen ? 'active' : ''
            }`} 
            onClick={toggleDropdown}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
            <i className={`fas fa-chevron-${isDropdownOpen ? 'up' : 'down'} dropdown-arrow`}></i>
          </div>
          <div className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
            {item.items.map((subItem) => (
              <Link
                key={subItem.path}
                to={subItem.path}
                className={`dropdown-item ${
                  location.pathname === subItem.path ? 'active' : ''
                }`}
                onClick={handleLinkClick}
              >
                <i className={subItem.icon}></i>
                <span>{subItem.label}</span>
              </Link>
            ))}
          </div>
        </div>
      );
    }

    return (
      <Link
        key={item.path}
        to={item.path}
        className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
        onClick={handleLinkClick}
      >
        <i className={item.icon}></i>
        <span>{item.label}</span>
      </Link>
    );
  };

  return (
    <div className={`landlord-sidebar ${isOpen ? 'active' : ''}`}>
      <div className="sidebar-header">
        <Link to="/" className="" onClick={handleLinkClick}>
          <img src="/images/home_hive.png" alt="Logo" className="sidebar-logo" />
        </Link>
      </div>
      
      <div className="sidebar-content">
        <nav className="sidebar-nav">
          {menuItems.map((item) => renderMenuItem(item))}
        </nav>

        <div className="sidebar-footer">
          <Link to="/logout" className="sidebar-link logout-link" onClick={handleLinkClick}>
            <i className="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 